module.exports = __webpack_public_path__ + "media/featured/Goop-6b0fbf16.png";